var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarNotCheckedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1173_2655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.01 120.01C93.1416 120.01 120 93.1471 120 60.01C120 26.8729 93.1416 0.0100098 60.01 0.0100098C26.8785 0.0100098 0.0200195 26.8729 0.0200195 60.01C0.0200195 93.1471 26.8785 120.01 60.01 120.01Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.01 29.49H58.99C50.7002 29.49 43.98 36.2102 43.98 44.5V61.71C43.98 69.9998 50.7002 76.72 58.99 76.72H61.01C69.2998 76.72 76.02 69.9998 76.02 61.71V44.5C76.02 36.2102 69.2998 29.49 61.01 29.49Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3099 114.91C77.9799 117.74 70.2499 119.62 60.2199 119.99C50.0799 120 43.0099 117.9 35.5599 114.85C27.2299 110.88 20.3799 106.04 16.3599 101.13C19.4299 95.0799 25.0499 90.2699 33.0099 87.9399H87.1099C95.2199 90.5199 100.43 95.1599 103.34 101.42C98.5999 106.6 92.2399 111.15 84.3099 114.91Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0098 62.13H67.9898C67.9198 65.36 64.2398 69.12 60.4498 69.04C56.1298 68.93 52.1198 65.05 52.0098 62.13Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9202 3.77002C90.7802 3.77002 115.89 28.89 115.89 59.77C115.89 90.65 90.7802 115.77 59.9202 115.77C29.0602 115.77 3.9502 90.64 3.9502 59.77C3.9502 28.9 29.0602 3.77002 59.9202 3.77002ZM59.9202 -0.22998C26.8002 -0.22998 -0.0498047 26.63 -0.0498047 59.77C-0.0498047 92.91 26.8002 119.77 59.9202 119.77C93.0402 119.77 119.89 92.91 119.89 59.77C119.89 26.63 93.0402 -0.22998 59.9202 -0.22998Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1173_2655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarNotCheckedIn);
export default __webpack_public_path__ + "static/media/avatarNotCheckedIn.53e2998967a1d438e45714a796b6d262.svg";
export { ForwardRef as ReactComponent };